import { formatAmount } from 'src/helpers/payments'

const formatCost = (cost: number) => `$${formatAmount(cost)}`

export default formatCost
